import classNames from "classnames";
import { capitalize } from "lodash";
import { OverlayTrigger } from "react-bootstrap";
import { InvoiceStatus as InvoiceStatusEnum } from "../../common/types/invoice";
import { DynamicTooltip } from "../general/DynamicTooltip";
import styles from "./InvoiceStatus.module.scss";

interface InvoiceStatusProps {
    status: InvoiceStatusEnum;
    className?: string;
    showText?: boolean;
    label?: string;
    textClassName?: string;
}

export const InvoiceStatus: React.FC<InvoiceStatusProps> = ({
    status,
    className,
    showText = false,
    label,
    textClassName,
}) => {
    const statusDot = (
        <div className={classNames(styles.statusContainer, className)}>
            <div className={classNames(styles.statusDot, styles[status])} />
            {showText && (
                <span className={classNames(styles.statusText, textClassName)}>
                    {label ?? capitalize(status)}
                </span>
            )}
        </div>
    );

    if (showText) {
        return statusDot;
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <DynamicTooltip id={`invoice-status-${status}`}>
                    {capitalize(status)}
                </DynamicTooltip>
            }
        >
            {statusDot}
        </OverlayTrigger>
    );
};
